<template>
  <div class="lms-wrapper-two">
    <student-nav ></student-nav>
    <div class="lms-content">
      <student-header class="filled" @toggle-navbar="toggleNavbar($event)" />
      <div class="lms-content-body container " style="bottom: 0; height: calc(100vh - 80px)">
        
        <div class="px-4 py-4 bg-white mg-t-20 rounded-20">
          
          <!-- v-if="learnExamRegistration == 1" -->
          <exam-point v-if="$route.params.mode === -1"></exam-point>
          <exam-registration-egazar v-else-if="$store.state.app.activeGroup.id === 9379" :from-home="false" />
          <exam-registration v-else  />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StudentNav from '@/views/modules/lms/student/components/nav.vue';
import StudentHeader from '@/views/modules/lms/student/components/header.vue';
import ExamPoint from '@/views/modules/lms/student/components/examPoint2025/examPoint.vue';

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  name: 'Examr',
  components: {
    StudentNav,
    StudentHeader,
    ExamPoint,
    examRegistration: () => ({
      component: import(
        "@/views/modules/lms/student/components/examRegistration2025"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    examRegistrationEgazar: () => ({
      component: import(
        "@/views/modules/lms/student/components/examRegistrationEgazar"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      scrollHeight: {
        content: 0,
      },
    };
  },
  methods: {
    toggleNavbar(event) {
      this.$emit('toggle-navbar', event);
    },
  },
}
</script>